import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ManualSlotPicker = ({ zoneId, getAuth, onCreated, prefix }) => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [saving, setSaving] = useState(false);

  const create = async () => {
    if (!date || !start || !end) {
      toast.error("Remplissez la date et les heures");
      return;
    }
    if (end <= start) {
      toast.error("L'heure de fin doit être après l'heure de début");
      return;
    }
    const headers = getAuth();
    if (!headers) return;
    setSaving(true);
    try {
      const res = await axios.post(`${API}/admin/slots`, {
        zone_id: zoneId, date, start_time: start, end_time: end, max_bookings: 1
      }, { headers });
      onCreated(res.data, new Date(`${date}T00:00:00`));
      toast.success("Créneau manuel ajouté");
      setOpen(false);
    } catch (error) {
      toast.error("Erreur lors de la création du créneau");
    } finally {
      setSaving(false);
    }
  };

  if (!open) {
    return (
      <Button type="button" variant="outline" size="sm" className="mt-4" onClick={() => setOpen(true)} data-testid={`${prefix}-manual-slot-btn`}>
        <Clock className="w-4 h-4 mr-2" />
        Créneau manuel
      </Button>
    );
  }

  return (
    <div className="mt-4 p-3 rounded-lg border border-dashed border-slate-300 bg-slate-50 space-y-2" data-testid={`${prefix}-manual-slot-form`}>
      <p className="text-sm font-medium">Créneau manuel</p>
      <Input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid={`${prefix}-manual-date`} />
      <div className="grid grid-cols-2 gap-2">
        <Input type="time" value={start} onChange={(e) => setStart(e.target.value)} data-testid={`${prefix}-manual-start`} />
        <Input type="time" value={end} onChange={(e) => setEnd(e.target.value)} data-testid={`${prefix}-manual-end`} />
      </div>
      <div className="flex gap-2">
        <Button type="button" variant="ghost" size="sm" onClick={() => setOpen(false)}>Annuler</Button>
        <Button type="button" size="sm" className="bg-pink-500 hover:bg-pink-600" disabled={saving} onClick={create} data-testid={`${prefix}-manual-confirm`}>
          {saving ? "Ajout..." : "Utiliser ce créneau"}
        </Button>
      </div>
    </div>
  );
};
